import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';



@Injectable()

export class ButtonsActivateService {

    public switchedBtnInfo = new Subject<boolean>();
    public switchedBtnPrint = new Subject<boolean>();
    public switchedBtnAdjunto = new Subject<boolean>();
    public switchedBtnAdjuntoHasItems = new Subject<boolean>();

    constructor() { }

    observerisBtnInfoOn() {
        return this.switchedBtnInfo.asObservable();
    }
    actualizarBtnInfo(BtnInfo) {
        this.switchedBtnInfo.next(BtnInfo);
    }

    observerisBtnPrintOn() {
        return this.switchedBtnPrint.asObservable();
    }
    actualizarBtnPrint(BtnPrint) {
        this.switchedBtnPrint.next(BtnPrint);
    }

    observerisBtnAdjuntoOn() {
        return this.switchedBtnAdjunto.asObservable();
    }
    actualizarBtnAdjunto(BtnAdjunto) {
        this.switchedBtnAdjunto.next(BtnAdjunto);
        if (!BtnAdjunto) {
            this.actualizarBtnAdjuntoHasItems(false);
        }
    }

    observerBtnAdjuntoHasItemsOn() {
        return this.switchedBtnAdjuntoHasItems.asObservable();
    }
    actualizarBtnAdjuntoHasItems(HasItems) {
        this.switchedBtnAdjuntoHasItems.next(HasItems);
    }


}
